// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mprof-head {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
}

.mprof-title {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 4px;
    color: var(--md-ink, #0f172a);
}

.mprof-sub {
    margin: 0;
    color: var(--md-muted, #64748b);
    font-size: 14px;
    max-width: 42rem;
}

.mprof-head-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.mprof-save-error {
    flex-basis: 100%;
    margin: 0;
    color: #dc2626;
    font-size: 13px;
}

.mprof-card {
    background: #fff;
    border: 1px solid var(--md-line, #e2e8f0);
    border-radius: 12px;
    padding: 18px 20px;
    margin-bottom: 16px;
}

.mprof-card-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.mprof-card-head h2 {
    font-size: 13px;
    font-weight: 700;
    margin: 0;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--md-ink, #0f172a);
}

.mprof-progress-label {
    font-size: 13px;
    font-weight: 600;
    color: #334155;
}

.mprof-progress {
    height: 8px;
    background: #e2e8f0;
    border-radius: 999px;
    overflow: hidden;
    margin-bottom: 14px;
}

.mprof-progress span {
    display: block;
    height: 100%;
    background: #1d4ed8;
    border-radius: 999px;
}

.mprof-check-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.mprof-check-list li {
    display: grid;
    grid-template-columns: 20px 1fr auto;
    gap: 8px 10px;
    align-items: center;
    padding: 8px 0;
    border-top: 1px solid #f1f5f9;
    font-size: 14px;
}

.mprof-check-list li:first-child {
    border-top: 0;
    padding-top: 0;
}

.mprof-check-list i {
    font-size: 16px;
}

.mprof-check-list .is-done i {
    color: #15803d;
}

.mprof-check-list .is-pending i {
    color: #94a3b8;
}

.mprof-check-name {
    color: var(--md-ink, #0f172a);
}

.mprof-check-status {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
}

.mprof-check-list .is-done .mprof-check-status {
    color: #15803d;
}

.mprof-check-action {
    grid-column: 2 / -1;
    font-size: 12px;
    color: #64748b;
}

.mprof-identity {
    display: flex;
    gap: 14px;
    align-items: flex-start;
    margin-bottom: 16px;
}

.mprof-avatar {
    width: 56px;
    height: 56px;
    font-size: 16px;
}

.mprof-avatar-img {
    width: 56px;
    height: 56px;
    border-radius: 999px;
    object-fit: cover;
}

.mprof-name {
    margin: 0 0 2px;
    font-weight: 700;
    font-size: 18px;
    color: var(--md-ink, #0f172a);
}

.mprof-identity-line {
    margin: 0 0 8px;
    font-size: 14px;
    color: #334155;
}

.mprof-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.mprof-chip {
    display: inline-block;
    background: #f1f5f9;
    color: #334155;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 10px;
}

.mprof-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.mprof-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 12px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #475569;
}

.mprof-grid .mprof-field {
    margin-bottom: 0;
}

.mprof-field-hint {
    text-transform: none;
    letter-spacing: 0;
    font-weight: 500;
    color: #64748b;
}

.mprof-helper {
    margin: 0 0 6px;
    font-size: 14px;
    color: #334155;
}

.mprof-truth {
    margin: 0 0 12px;
    font-size: 13px;
    color: #1e3a8a;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 8px;
    padding: 8px 10px;
}

.mprof-track-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 14px;
}

.mprof-track-chip {
    border: 1px solid #cbd5e1;
    background: #fff;
    color: #334155;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    padding: 6px 12px;
}

.mprof-track-chip.is-selected {
    background: #1d4ed8;
    border-color: #1d4ed8;
    color: #fff;
}

.mprof-muted {
    font-size: 13px;
    color: #64748b;
    margin: 0 0 12px;
}

.mprof-toggles {
    list-style: none;
    margin: 0;
    padding: 0;
}

.mprof-toggles li {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 0;
    border-top: 1px solid #f1f5f9;
}

.mprof-toggles li:first-child {
    border-top: 0;
    padding-top: 0;
}

.mprof-toggle-label {
    margin: 0 0 2px;
    font-weight: 600;
    font-size: 14px;
    color: var(--md-ink, #0f172a);
}

.mprof-toggle-sub {
    margin: 0 0 4px;
    font-size: 13px;
    color: #475569;
}

.mprof-toggle-note {
    margin: 0;
    font-size: 12px;
    color: #64748b;
}

@media (max-width: 767px) {
    .mprof-grid {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/mentorship/mentorProfile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".mprof-head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.mprof-title {\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0 0 4px;\n    color: var(--md-ink, #0f172a);\n}\n\n.mprof-sub {\n    margin: 0;\n    color: var(--md-muted, #64748b);\n    font-size: 14px;\n    max-width: 42rem;\n}\n\n.mprof-head-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.mprof-save-error {\n    flex-basis: 100%;\n    margin: 0;\n    color: #dc2626;\n    font-size: 13px;\n}\n\n.mprof-card {\n    background: #fff;\n    border: 1px solid var(--md-line, #e2e8f0);\n    border-radius: 12px;\n    padding: 18px 20px;\n    margin-bottom: 16px;\n}\n\n.mprof-card-head {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.mprof-card-head h2 {\n    font-size: 13px;\n    font-weight: 700;\n    margin: 0;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--md-ink, #0f172a);\n}\n\n.mprof-progress-label {\n    font-size: 13px;\n    font-weight: 600;\n    color: #334155;\n}\n\n.mprof-progress {\n    height: 8px;\n    background: #e2e8f0;\n    border-radius: 999px;\n    overflow: hidden;\n    margin-bottom: 14px;\n}\n\n.mprof-progress span {\n    display: block;\n    height: 100%;\n    background: #1d4ed8;\n    border-radius: 999px;\n}\n\n.mprof-check-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.mprof-check-list li {\n    display: grid;\n    grid-template-columns: 20px 1fr auto;\n    gap: 8px 10px;\n    align-items: center;\n    padding: 8px 0;\n    border-top: 1px solid #f1f5f9;\n    font-size: 14px;\n}\n\n.mprof-check-list li:first-child {\n    border-top: 0;\n    padding-top: 0;\n}\n\n.mprof-check-list i {\n    font-size: 16px;\n}\n\n.mprof-check-list .is-done i {\n    color: #15803d;\n}\n\n.mprof-check-list .is-pending i {\n    color: #94a3b8;\n}\n\n.mprof-check-name {\n    color: var(--md-ink, #0f172a);\n}\n\n.mprof-check-status {\n    font-size: 12px;\n    font-weight: 600;\n    color: #64748b;\n}\n\n.mprof-check-list .is-done .mprof-check-status {\n    color: #15803d;\n}\n\n.mprof-check-action {\n    grid-column: 2 / -1;\n    font-size: 12px;\n    color: #64748b;\n}\n\n.mprof-identity {\n    display: flex;\n    gap: 14px;\n    align-items: flex-start;\n    margin-bottom: 16px;\n}\n\n.mprof-avatar {\n    width: 56px;\n    height: 56px;\n    font-size: 16px;\n}\n\n.mprof-avatar-img {\n    width: 56px;\n    height: 56px;\n    border-radius: 999px;\n    object-fit: cover;\n}\n\n.mprof-name {\n    margin: 0 0 2px;\n    font-weight: 700;\n    font-size: 18px;\n    color: var(--md-ink, #0f172a);\n}\n\n.mprof-identity-line {\n    margin: 0 0 8px;\n    font-size: 14px;\n    color: #334155;\n}\n\n.mprof-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.mprof-chip {\n    display: inline-block;\n    background: #f1f5f9;\n    color: #334155;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 600;\n    padding: 4px 10px;\n}\n\n.mprof-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n}\n\n.mprof-field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-bottom: 12px;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #475569;\n}\n\n.mprof-grid .mprof-field {\n    margin-bottom: 0;\n}\n\n.mprof-field-hint {\n    text-transform: none;\n    letter-spacing: 0;\n    font-weight: 500;\n    color: #64748b;\n}\n\n.mprof-helper {\n    margin: 0 0 6px;\n    font-size: 14px;\n    color: #334155;\n}\n\n.mprof-truth {\n    margin: 0 0 12px;\n    font-size: 13px;\n    color: #1e3a8a;\n    background: #eff6ff;\n    border: 1px solid #bfdbfe;\n    border-radius: 8px;\n    padding: 8px 10px;\n}\n\n.mprof-track-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 14px;\n}\n\n.mprof-track-chip {\n    border: 1px solid #cbd5e1;\n    background: #fff;\n    color: #334155;\n    border-radius: 999px;\n    font-size: 13px;\n    font-weight: 600;\n    padding: 6px 12px;\n}\n\n.mprof-track-chip.is-selected {\n    background: #1d4ed8;\n    border-color: #1d4ed8;\n    color: #fff;\n}\n\n.mprof-muted {\n    font-size: 13px;\n    color: #64748b;\n    margin: 0 0 12px;\n}\n\n.mprof-toggles {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.mprof-toggles li {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 12px 0;\n    border-top: 1px solid #f1f5f9;\n}\n\n.mprof-toggles li:first-child {\n    border-top: 0;\n    padding-top: 0;\n}\n\n.mprof-toggle-label {\n    margin: 0 0 2px;\n    font-weight: 600;\n    font-size: 14px;\n    color: var(--md-ink, #0f172a);\n}\n\n.mprof-toggle-sub {\n    margin: 0 0 4px;\n    font-size: 13px;\n    color: #475569;\n}\n\n.mprof-toggle-note {\n    margin: 0;\n    font-size: 12px;\n    color: #64748b;\n}\n\n@media (max-width: 767px) {\n    .mprof-grid {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
